import { getLocalUserInfo } from "../../utility/authHelper";
import BusTypeRoutes from "./BusType";
import CompanyRoutes from "./Company";
import ConfigurationRoutes from "./Configuration";
import CounterRoutes from "./Counter";
// import MockResponseServicesRoutes from "./MockResponseServices";
import PaymentGatewayRoutes from "./PaymentGateway";
import PromotionServicesRoutes from "./PromotionServices";
import SeatClassRoutes from "./SeatClass";
import SeatPlanRoutes from "./SeatPlan";
import StaticRoutes from "./Static";
import StationRoutes from "./Station";
import TripListRoutes from "./TripList";
import TripRoutes from "./TripRoute";
import TripScheduleRoutes from "./TripSchedule";
import UserManagementRoutes from "./UserManagement";
import ZoneRoutes from "./Zone";
import EmailTemplate from "./EmailTemplate";
import AgentManagementRoutes from "./AgentManagement";
import CounterAdminRoutes from "./CounterAdmin";
import TransactionRules from "./TransactionRules";
import Ticket from "./Ticket";
import CounterFundRequestRoutes from "./CounterFundRequest";
import ReportRoutes from "./ReportRoutes";
import CallCenterRoutes from "./CallCenter";
import DeckSection from "./DeckSection";
import SeatTypeRoutes from "./SeatType";
import CompanySeatTypeRoutes from "./CompanySeatType";
import {ROLE_TYPES} from "../../utility/constants";
import RouteAssign from "./RouteAssign";
import ManufacturerRoutes from "./Manufacturer";
import ContentManagement from "./ContentManagement";

const getAllRoutes = (roleType) => {
    let counterAdminRoutes = [...CounterAdminRoutes];
    let callCenterRoutes = [...CallCenterRoutes];

    if ([ROLE_TYPES.COMPANY_COUNTER, ROLE_TYPES.COMPANY_CALL_CENTRE_MANAGER].includes(roleType) &&
        counterAdminRoutes.length) {
        try {
            counterAdminRoutes = counterAdminRoutes[0].children.map((route) => {
                if (route.path === "counter-panel") {
                    route.displayName = "Counter Dashboard";
                }

                route.path = route.fullPath;
                route.displayPath = route.displayPath.replace(
                    "CounterAdmin > ",
                    ""
                );
                return route;
            });
        } catch (e) {}
    }

    if (roleType === ROLE_TYPES.GDS_CALL_CENTRE_AGENT && callCenterRoutes.length) {
        try {
            callCenterRoutes = callCenterRoutes[0].children.map((route) => {
                if (route.fullPath === "call-center/dashboard") {
                    route.path = "/";
                    delete route.fullPath;
                } else {
                    route.path = route.fullPath;
                }

                route.displayPath = route.displayPath.replace(
                    "Call Center > ",
                    ""
                );
                return route;
            });
            return callCenterRoutes;
        } catch (e) {}
    }

    return [
        ...CompanyRoutes,
        ...StationRoutes,
        ...ZoneRoutes,
        ...CounterRoutes,
        ...TripRoutes,
        ...TripScheduleRoutes,
        ...DeckSection,
        // ...SeatTypeRoutes,
        ...CompanySeatTypeRoutes,
        ...SeatPlanRoutes,
        ...SeatClassRoutes,
        ...BusTypeRoutes,
        ...ManufacturerRoutes,
        ...TripListRoutes,
        ...PaymentGatewayRoutes,
        //...PromotionServicesRoutes,
        ...ContentManagement,
        ...ConfigurationRoutes,
        ...UserManagementRoutes,
        ...AgentManagementRoutes,
        ...EmailTemplate,
        ...counterAdminRoutes,
        ...TransactionRules,
        ...Ticket,
        ...CounterFundRequestRoutes,
        ...ReportRoutes,
        ...callCenterRoutes,
        ...RouteAssign,
    ];
};

let roleType = "";

const getPermittedRoutes = () => {
    const { permissions, role_type } = getLocalUserInfo();
    roleType = role_type;
    return getRoutes(getAllRoutes(role_type), permissions || []);
};

const filterableSidebarMenus = [];

const getRoutes = (routes, permissions, showChildren = false) => {
    const permittedRoutes = [];
    routes.forEach((route) => {
        if (route.children && route.children.length) {
            route.children = getRoutes(
                route.children,
                permissions,
                route.showChildren
            );
            if (route.children.length) {
                permittedRoutes.push(route);
                addInFilterableSidebarMenus(route);
            }
        } else {
            if (route.permissions && route.permissions.length) {
                const availablePermsissions = route.permissions.filter(
                    (permission) => permissions.includes(permission)
                );

                if (availablePermsissions.length) {
                    permittedRoutes.push(route);
                    if (showChildren) addInFilterableSidebarMenus(route);
                }
            } else {
                permittedRoutes.push(route);
                if (showChildren) addInFilterableSidebarMenus(route);
            }
        }
    });

    return permittedRoutes;
};

const addInFilterableSidebarMenus = (route) => {
    if (route.sidebarMenu) {
        filterableSidebarMenus.push(route);
    }
};

const permittedRoutes = getPermittedRoutes();

const getAuthRoutes = () => {
    if (roleType === ROLE_TYPES.GDS_CALL_CENTRE_AGENT) {
        return [
            ...permittedRoutes,
            ...StaticRoutes.filter(({ path }) => path !== "/"),
        ];
    } else {
        return [
            ...StaticRoutes,
            ...permittedRoutes,
            // ...MockResponseServicesRoutes,
        ];
    }
};

const AuthRoutes = getAuthRoutes();

const sidebarMenus = [];

AuthRoutes.forEach((menu) => {
    if (menu.sidebarMenu) {
        sidebarMenus.push(menu);
    }
});

export default AuthRoutes;

export { sidebarMenus, filterableSidebarMenus };
